var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-spacer'),_c('SearchField',{model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_c('ChangeLogTable',{attrs:{"items":_vm.itemsFiltered,"items-per-page":-1,"showCoursePart":true,"showPerson":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }